import { connect } from 'react-redux';
import BuatKlasifikasi from '../../../views/Library/TableKlasifikasi/BuatKlasifikasi.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(BuatKlasifikasi);
